<template>
  <v-app id="app">
    <v-main>
      <loader ref="loader"></loader>
      <Subscribe ref="subscribe" />
      <confirm ref="confirm"></confirm>
      <TopBar />
      <v-slide-x-reverse-transition mode="out-in">
        <Screener :slug="selectedSlug" :key="selectedSlug" />
      </v-slide-x-reverse-transition>

      <!-- message/error notification -->
      <v-snackbar
        :timeout="$store.state.snackbar.timeout"
        top
        right
        :color="$store.state.snackbar.color"
        v-model="$store.state.snackbar.show"
      >
        <!-- <v-icon color="white" small class="pr-2">notifications_active</v-icon> -->
        <span class="text-xs-center">{{ $store.state.snackbar.message }}</span>
        <template v-slot:action="{ attrs }">
        <v-btn
          icon
          v-bind="attrs"
          @click.native="hideSnackbar"
        >
          <v-icon>mdi-close-octagon-outline</v-icon>
        </v-btn>
        </template>
      </v-snackbar>
    </v-main>
  </v-app>
</template>

<style>
#app {
  font-family: Lato, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;
}
.v-tab {
  font-size: 14px !important;
  font-weight: 600 !important;
  text-transform: initial !important;
}
.top-bar .v-tab {
  color: #fff !important;
}

.row {
  display: flex !important;
  flex-wrap: wrap !important;
  flex: 1 1 auto !important;
  margin: 0 !important;
}

.screener-input .v-input__slot {
  min-height: 35px !important;
  height: 35px !important;
}
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}
</style>

<script>
import Subscribe from "@/components/utils/Subscribe.vue";
import loader from "@/components/utils/loader";
import confirm from "@/components/utils/confirm";
import Screener from "@/components/Screener.vue";
import TopBar from "@/components/TopBar.vue";
export default {
  name: "Home",
  components: { Screener, Subscribe, loader, confirm, TopBar },
  mounted() {
    this.$root.$loader = this.$refs.loader;
    this.$root.$subscribe = this.$refs.subscribe;
    this.$root.$confirm = this.$refs.confirm;
  },
  methods: {
     hideSnackbar() {
      this.$store.commit("hideSnackbar");
    }
  },
  computed: {
    selectedSlug() {
      return this.$store.getters.getScreenerId;
    },
  },
};
</script>